import React from "react";
import { useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import { selectUser } from "../redux/slices/userSlice";
import { selectTeams } from "../redux/slices/teamsSlice";
import { selectAssistants } from "../redux/slices/assistantsSlice";
import { selectFile } from "../redux/slices/fileSlice";

const spinnerStyles = `
.gundam-spinner-astray {
  --spinner-red: #ff4040;
  --spinner-silver: #e1e6ee;
  width: 60px;
  height: 60px;
  border: 3px solid var(--spinner-silver);
  border-top-color: var(--spinner-red);
  border-radius: 50%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 10px rgba(255, 64, 64, 0.5);
  animation: gundam-spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}
.gundam-spinner-inner-astray {
  width: 25px;
  height: 25px;
  background-color: var(--spinner-red);
  border: 2px solid #fff;
  border-radius: 50%;
  box-shadow: 0 0 15px var(--spinner-red);
  animation: gundam-core-pulse 1.5s infinite ease-in-out;
}
@keyframes gundam-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
@keyframes gundam-core-pulse {
  0% { transform: scale(0.8); opacity: 0.7; }
  50% { transform: scale(1.1); opacity: 1; }
  100% { transform: scale(0.8); opacity: 0.7; }
}
.loading-text-astray {
  font-family: 'Share Tech Mono', monospace, 'Noto Sans TC', '微軟正黑體', sans-serif;
  color: #fff;
  text-shadow: 0 0 8px rgba(255, 64, 64, 0.7);
  transition: all 0.3s;
}
`;

export default function LoadingOverlayFM() {
  const user = useSelector(selectUser);
  const teams = useSelector(selectTeams);
  const assistants = useSelector(selectAssistants);
  const file = useSelector(selectFile);

  const loading = user?.loading || teams?.loading || assistants?.loading || assistants?.loading2 || file?.loading;

  return (
    <>
      <style>{spinnerStyles}</style>
      <AnimatePresence>
        {loading && (
          <motion.div
            key="loading"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
            className="d-flex flex-column align-items-center justify-content-center"
            style={{
              zIndex: 9000,
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.001)",
              backdropFilter: "blur(2px) brightness(0.65)",
              pointerEvents: "auto",
            }}
            aria-live="assertive"
            role="alert"
            aria-atomic="true"
          >
            <motion.img
              src="https://heyadigi.com/wp-content/uploads/heyadigi-logo-icon.png"
              alt="Heyadigi Logo"
              className="mb-6 drop-shadow-lg"
              style={{ width: "200px", height: "60px", marginBottom: "16px" }}
              initial={{ scale: 0.5, opacity: 0, rotateY: -90 }}
              animate={{ scale: 1, opacity: 1, rotateY: 0 }}
              transition={{ duration: 0.4, ease: "easeOut", delay: 0.1 }}
            />

            <motion.div
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.3, duration: 0.5, ease: "easeOut" }}
              className="mb-3"
            >
              <div className="gundam-spinner-astray">
                <div className="gundam-spinner-inner-astray"></div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1, duration: 0.5, ease: "easeOut" }}
              className="loading-text-astray fw-bold text-uppercase"
              style={{ fontSize: "1.2rem", letterSpacing: "3px", marginTop: "12px" }}
            >
              SYSTEM BOOTING...
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
